import { useEffect, useState } from 'react';
import { Box } from '@chakra-ui/react';
import { GET_RELATED_ARTICLES_FOR_CATEGORY } from '../apollo/queries/GetRelatedArticlesForCateogry';
import { useApolloClient } from '@apollo/client';
import CustomCarousel from './Carousel';
import Card from './insideCard';

const ArticlesCarousel = ({ article }) => {
  const [articles, setArtciles] = useState(null);

  const client = useApolloClient();

  useEffect(() => {
    (async () => {
      if (article) {
        let data = await getRelatedArticles(article);

        setArtciles(data);
      }
    })();
  }, [article]);

  /**
   * Retrieves related articles for a given article by querying the server.
   * @param {ArticleData} article - The article to retrieve related articles for.
   */
  const getRelatedArticles = async (article) => {
    const { slug } = article.attributes.categories.data[0]?.attributes;

    if (!slug) {
      return [];
    }

    const { data, loading } = await client.query({
      query: GET_RELATED_ARTICLES_FOR_CATEGORY,
      context: { clientName: 'strapi' },
      variables: {
        filters: {
          slug: {
            eq: slug,
          },
        },
      },
      fetchPolicy: 'cache-first',
    });

    if (loading) {
      return [];
    }

    const relatedArticles =
      data.categories.data[0].attributes.articles.data.filter(
        (item: { id: any }) => item.id !== article.id
      );

    return relatedArticles;
  };
  return (
    <>
      {articles && articles.length > 2 && (
        <Box py={10}>
          <CustomCarousel paginationAndArrows itemsToShowInitial={3}>
            {articles.map((article: any, i: any) => {
              return <Card article={article} key={`article__left__${i}`} />;
            })}
          </CustomCarousel>
        </Box>
      )}
    </>
  );
};

export default ArticlesCarousel;
